import button from "assets/stylesheets/modules/components/button.module.scss";

const Button = {
  baseStyle: {
    color: "unset",
    fontWeight: button.fontWeight,
    fontSize: button.fontSizeLg,
    paddingX: button.paddingX,
    paddingY: button.paddingY,
    borderRadius: "lg",
    textDecoration: "none",
    textWrap:"wrap",
    _hover: {
      textDecoration: "none",
    },
  },
  sizes: {
    sm: {
      paddingX: button.smPaddingX,
      paddingY: button.smPaddingY,
      borderRadius: "md",
    },
    lg: {
      fontSize: button.fontSizeLg,
      paddingX: button.lgPaddingX,
      paddingY: button.lgPaddingY,
      borderRadius: "lg",
    },
  },
  variants: {
    solid: ({ colorScheme }) => {
      return {
        borderBottom: "none",
        outline: "none",
        boxShadow: "none",
        textDecoration: "none",
        _hover: {
          background: `${colorScheme}.700`,
          color: ["light", "orange", "yellow"].includes(colorScheme)
            ? "black"
            : "white",
        },
      };
    },
    link: ({ colorScheme = "pink" }) => {
      return {
        textDecoration: "underline",
        color: `${colorScheme}.500`,
        _hover: {
          color: `${colorScheme}.700`,
          textDecoration: "underline",
        },
      };
    },
    outline: ({ colorScheme }) => {
      return {
        color: `${colorScheme}.500`,
        borderColor: `${colorScheme}.500`,
        textDecoration: "none",
        _hover: {
          background: `${colorScheme}.500`,
          color: ["light", "orange", "yellow"].includes(colorScheme)
            ? "black"
            : "white",
        },
      };
    },
    secondary: {
      background: "gray.300",
      color: "gray.800",
      textDecoration: "none",
      _hover: {
        background: "gray.400",
        color: "gray.800",
      },
      _disabled: {
        background: "gray.200",
        color: "gray.600",
        opacity: 1,
      },
    },
  },
};

export default Button;
